import React from "react";
import ResourcesContent from "../FunctionComponents/ResourcesFolder/ResourcesContent";

function Resources() {
  return (
    <>
      <ResourcesContent />
    </>
  );
}

export default Resources;
